export const tableEnUSTranslations = {
  editMode: "Edit mode:",
  emptyTableMessage: "Nothing to see here… yet! 💤",
  columns: "Columns",
  toggleColumnVisibility: "Toggle Column Visibility",
  tableActions: "Table actions",
  filterTable: "Filter table",
  filterClear: "Clear",
  textOperatorIs: "is",
  textOperatorIsNot: "is not",
  textOperatorIsAnyOf: "is any of",
  textOperatorIsNotAnyOf: "is not any of",
  dateOperatorEq: "Is exactly",
  dateOperatorGt: "Is after",
  dateOperatorGte: "Is on or after",
  dateOperatorLt: "Is before",
  dateOperatorLte: "Is on or before",
  numericOperatorEq: "Is equal to",
  numericOperatorGt: "Is greater than",
  numericOperatorGte: "Is greater than or equal to",
  numericOperatorLt: "Is less than",
  numericOperatorLte: "Is less than or equal to",
  booleanYes: "Yes",
  booleanNo: "No",
  compoundFilter: "Compound filter",
  compoundFilterAnd: "Compound filter (AND)",
  compoundFilterOr: "Compound filter (OR)",
  paginationItem: "item",
  paginationItems: "items",
};
